import React from "react";
import {Placeholder} from "react-bootstrap";

export default function Loader({ text = 'Loading...' }) {

  return (
    <div className="bg-white p-2 rounded shadow py-5">
      <Placeholder animation="glow">
        {Array(10).fill('1').map(() => (<Placeholder xs={12} bg="branding" />))}
      </Placeholder>
    </div>
  )
};
